module.exports = __webpack_public_path__ + "img/22.a4d0833c.jpg";